export const SERVICE_DESK_LINK = 'https://insignary.atlassian.net/servicedesk/customer/portal/1/group/1';
export const RESTFUL_API_SAMPLE_LINK = '/2/apis/sample';
export const RESTFUL_API_GUIDE_LINK = '/2/apis/guide';
export const OPEN_SOURCE_LICENSE_LINK = '/1/help/license';
export const HOW_TO_USE_LINK = 'https://s3.amazonaws.com/clarity-userguide/Latest_User_Guide.pdf';
export const HOW_TO_USE_LINK_KO = 'https://s3.amazonaws.com/clarity-userguide/Latest_User_Guide_Ko.pdf';
export const HOW_TO_USE_LINK_JA = 'https://s3.amazonaws.com/clarity-userguide/Latest_User_Guide_Ja.pdf';
export const NVD_LINK = 'https://nvd.nist.gov/vuln/detail/';
export const WEB_SERVICE_LOG_LINK = '/1/logs/service';
export const USER_SIGN_IN_OUT_LOG_LINK = '/1/logs/sign_in';
export const USER_ACCESS_LOG_LINK = '/1/logs/access';
export const SCAN_HISTORY_LINK = '/1/logs/scan';
export const ECLIPSE_GUIDE_LINK = '/1/ides/eclipse_guid';
export const ECLIPSE_PLUGIN_LINK = '/1/ides/eclipse_plugin';
export const NVD_DATA_FEED_LINK = 'https://nvd.nist.gov/vuln/data-feeds';
export const CNVD_DATA_FEED_LINK = 'https://www.cnvd.org.cn/webinfo/list?type=7';
